import { Menu } from 'lucide-react';
import { Suspense, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, ScrollRestoration, useLocation } from 'react-router-dom';

import { useCurrentUser } from '../../lib/auth';
import { Toaster } from '../ui/sonner';

import { AdminSidebar } from './AdminSidebar';

export function AdminLayout() {
  const { user, loading } = useCurrentUser();
  const location = useLocation();
  const { t } = useTranslation(['admin', 'common']);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        {t('common:loading')}
      </div>
    );
  }

  if (!user) {
    return <Navigate replace to={`/account/login?next=${encodeURIComponent(location.pathname)}`} />;
  }

  if (!user.groups.includes('PLATFORM_ADMIN')) {
    return <Navigate replace to="/" />;
  }

  return (
    <>
      <div className="flex h-screen overflow-hidden bg-background">
        <AdminShell />
      </div>
      <Toaster />
    </>
  );
}

function AdminShell() {
  const location = useLocation();
  const { t } = useTranslation('admin');
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  useEffect(() => {
    setMobileSidebarOpen(false);
  }, [location.pathname]);

  return (
    <>
      <AdminSidebar
        mobileOpen={mobileSidebarOpen}
        onMobileClose={() => setMobileSidebarOpen(false)}
      />
      <main className="flex flex-1 flex-col overflow-y-auto min-w-0">
        <div className="flex h-14 shrink-0 items-center border-b border-border/60 bg-card px-4 md:hidden">
          <button
            aria-label={t('nav.openMenu')}
            className="rounded-lg p-2 text-foreground hover:bg-muted/50"
            onClick={() => setMobileSidebarOpen(true)}
            type="button"
          >
            <Menu className="h-5 w-5" />
          </button>
          <span className="ml-3 text-sm font-semibold text-foreground">{t('nav.admin')}</span>
        </div>
        <ScrollRestoration />
        <Suspense fallback={<div className="flex-1 animate-pulse bg-muted/30" />}>
          <Outlet />
        </Suspense>
      </main>
    </>
  );
}
